import React from 'react';
import './Study.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Spinner from '../Spinner/Spinner';
import { withRouter } from "react-router";
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from './StudyCenterHeader';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
const chapters = ['Property Fall 2020', 'Iron Dwarf', 'Highborn Human', 'Lowland Human', 'Mountain Dwarf', 'Scythian Elf', 'Woodland Elf'];
export class StudyCenterProfessor extends React.Component {
    constructor(props) {
        super(props);
        this.DropdownRef = React.createRef();
        this.state = {
            progress: 50,
            bookISBN: "",
            haveText: "",
            bookTitle: "",
            isOpen: false,
            loading: false,
            viewTopic: false,
            classVOList: null,
            routeChangeMsg: '',
            chapterNavTitle: "",
            currentClassId: null,
            studyDashBoardVO: null,
            learningObjectiveProgressVOList: [],
            bookVO: JSON.parse(localStorage.getItem('bookVO')),
            userVO: JSON.parse(localStorage.getItem('userVO')),
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false",
        };
        this.navigateToChapterStudyCenter = this.navigateToChapterStudyCenter.bind(this);
        this.handleText = this.handleText.bind(this);
        this.Dropdowncontainer = React.createRef();
    }
    componentDidMount = () => {
        this.getClassDetails();
        document.title = `${this.state.bookVO !== null ? `${this.state.bookVO.bookTitle} |` : ""} Contents | Study Center | Aspen Publishing`;
    }
    componentWillUnmount() { }
    getClassDetails() {
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "StudyCenter",
                    "pageNavigatingTo": "StudyCenterQuestion"
                },
                sessionVO: {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                },
            },
            "bookVO": { "bookISBN": this.props.match.params.isbn }
        }
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        };
        this.setState({ "loading": true })
        fetch(localStorage.getItem('ENV') + "/manageClassWebService/getAllClassByIsbn", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    var bookVO = data.bookVO, classVOList = data.classVOList;
                    {
                        var classId = null;
                        if (classVOList) {
                            classVOList = Array.isArray(classVOList) ? classVOList : [classVOList]
                            classId = classVOList[0].classId
                        }
                        let reqData2 = {
                            "userVO": {
                                "userId": this.state.userVO.userId,
                                "userRole": this.state.userVO.userRole,
                                "userRoleId": this.state.userVO.userRoleId,
                                "userActivityVO": {
                                    "lastActivityCode": "BOOKSHELF",
                                    "pageNavigatingFrom": "StudyCenter",
                                    "pageNavigatingTo": "StudyCenterQuestion"
                                },
                                sessionVO: {
                                    "appType": "web",
                                    "deviceMacId": "",
                                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                                    "deviceOS": localStorage.getItem('deviceOS'),
                                    "deviceType": localStorage.getItem('deviceType'),
                                    "browserName": localStorage.getItem('browserName'),
                                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                                },
                            },
                            "bookVO": {
                                "classId": classId,
                                "bookId": bookVO.bookId,
                                "bookISBN": this.props.match.params.isbn
                            }
                        }
                        const requestOptions2 = {
                            method: 'POST',
                            body: JSON.stringify(reqData2),
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        };
                        fetch(localStorage.getItem('ENV') + "/manageClassWebService/getStudyDashBoardForProfessorOrStudentRv", requestOptions2)
                            .then(response => response.json())
                            .then(data2 => {
                                if (data2.status === "true") {
                                    if (data2.studyDashBoardVO) {
                                        var studyDashBoardDetail = data2.studyDashBoardVO.studyDashBoardDetail;
                                        if (studyDashBoardDetail) {
                                            studyDashBoardDetail = Array.isArray(studyDashBoardDetail) ? studyDashBoardDetail : [studyDashBoardDetail];
                                            data2.studyDashBoardVO.studyDashBoardDetail = studyDashBoardDetail;
                                        } else {
                                            data2.studyDashBoardVO.studyDashBoardDetail = null;
                                        }
                                        this.setState({
                                            "bookVO": bookVO, "classVOList": classId ? classVOList : null, "haveText": classId ? classVOList[0].className : "",
                                            "currentClassId": classId, "studyDashBoardVO": data2.studyDashBoardVO, "loading": false
                                        });
                                    }
                                } else if (data2.wkErrorCode) {
                                    handleException(data2);
                                }
                            }).catch(error => {
                                console.error("There has been a problem with your fetch operation:", error);
                                this.setState({ "loading": false })
                            });
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
                this.setState({ "loading": false })
            });
    }
    componentDidUpdate = (prevProps, prevState) => { }
    handleClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
    handleText = (ev) => {
        var classId = ev.currentTarget.getAttribute("classId");
        var className = ev.currentTarget.textContent;
        if (ev.currentTarget.getAttribute("classId")) {
            let reqData2 = {
                "userVO": {
                    "userId": this.state.userVO.userId,
                    "userRole": this.state.userVO.userRole,
                    "userRoleId": this.state.userVO.userRoleId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "StudyCenter",
                        "pageNavigatingTo": "StudyCenterQuestion"
                    },
                    sessionVO: {
                        "appType": "web",
                        "deviceMacId": "",
                        "keepMeLoggedInFlag": this.state.keepMeLogIn,
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                    },
                },
                "bookVO": {
                    "classId": classId,
                    "bookId": this.state.bookVO.bookId,
                    "bookISBN": this.props.match.params.isbn
                }
            }
            const requestOptions2 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData2)
            };
            fetch(localStorage.getItem('ENV') + "/manageClassWebService/getStudyDashBoardForProfessorOrStudentRv", requestOptions2)
                .then(response => response.json())
                .then(data2 => {
                    if (data2.status === "true") {
                        if (data2.studyDashBoardVO) {
                            var studyDashBoardDetail = data2.studyDashBoardVO.studyDashBoardDetail;
                            if (studyDashBoardDetail !== undefined) {
                                studyDashBoardDetail = Array.isArray(studyDashBoardDetail) ? studyDashBoardDetail : [studyDashBoardDetail];
                                data2.studyDashBoardVO.studyDashBoardDetail = studyDashBoardDetail;
                            } else {
                                data2.studyDashBoardVO.studyDashBoardDetail = null;
                            }
                            this.setState({
                                "currentClassId": classId, "studyDashBoardVO": data2.studyDashBoardVO, "haveText": className
                            });
                        }
                    } else if (data2.wkErrorCode) {
                        handleException(data2);
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                    this.setState({ "loading": false })
                });
        }
    }
    navigateToChapterStudyCenter = (e) => {
        this.setState({ "routeChangeMsg": `Navigating to the Chapter ${e.target.getAttribute("chapternum")} topics page` });
        setTimeout(() => {
            if (this.state.currentClassId)
                this.props.history.push(`/study/${this.props.match.params.isbn}/${e.target.getAttribute("chapterId")}#${this.state.currentClassId}`);
            else
                this.props.history.push(`/study/${this.props.match.params.isbn}/${e.target.getAttribute("chapterId")}`);
        }, 500);
    }
    render() {
        let itemList = props => {
            var schoolList = this.state.classVOList;
            if (schoolList) {
                const list = schoolList.map((item) => (
                    <div
                        onClick={this.handleText}
                        className="dropdown__item" classId={item.classId}
                        key={item.classId} classCode={item.classCode}>
                        {item.className}
                    </div>
                ));
                return (
                    <div className="dropdown__items"> {list} </div>
                )
            }
        }
        let getTotalQuestions = (distinctChapterResponseList) => {
            if (distinctChapterResponseList) {
                let totalQuestions = 0
                distinctChapterResponseList = Array.isArray(distinctChapterResponseList) ? distinctChapterResponseList : [distinctChapterResponseList];
                distinctChapterResponseList.map(x => (
                    totalQuestions += parseInt(x.totalQuestions ? x.totalQuestions : 0)
                ));
                return totalQuestions;
            } else
                return 0
        }
        let getProgressBar = (chapterVO, numberOfStudents, chapterId) => {
            let distinctChapterResponseList = chapterVO.distinctChapterResponseList;
            if (distinctChapterResponseList) {
                let totalNumberOfStudents = parseInt(numberOfStudents)
                if (totalNumberOfStudents > 0) {
                    let totalQuestions = 0, totalCorrectAnswer = 0, totalPartialCorrect = 0, totalUnAnswered = 0, totalWrongAnswer = 0
                    distinctChapterResponseList = Array.isArray(distinctChapterResponseList) ? distinctChapterResponseList : [distinctChapterResponseList];
                    distinctChapterResponseList.map(x => {
                        totalQuestions += parseInt(x.totalQuestions)
                        totalCorrectAnswer += parseInt(x.totalCorrectAnswer);
                        totalPartialCorrect += parseInt(x.totalPartialCorrect);
                        totalUnAnswered += parseInt(x.totalUnAnswered);
                        totalWrongAnswer += parseInt(x.totalWrongAnswer);
                    });
                    let correctPercentage = ((totalCorrectAnswer / ((totalQuestions * totalNumberOfStudents))) * 100)
                    let wrongPercentage = ((totalWrongAnswer / ((totalQuestions * totalNumberOfStudents))) * 100)
                    let partialPercentage = ((totalPartialCorrect / ((totalQuestions * totalNumberOfStudents))) * 100)
                    let unansweredPercentage = ((totalUnAnswered / ((totalQuestions * totalNumberOfStudents))) * 100)
                    correctPercentage = parseFloat(correctPercentage % 1 === 0 ? Math.round(correctPercentage) : correctPercentage.toFixed(2))
                    wrongPercentage = parseFloat(wrongPercentage % 1 === 0 ? Math.round(wrongPercentage) : wrongPercentage.toFixed(2))
                    partialPercentage = parseFloat(partialPercentage % 1 === 0 ? Math.round(partialPercentage) : partialPercentage.toFixed(2))
                    unansweredPercentage = parseFloat(unansweredPercentage % 1 === 0 ? Math.round(unansweredPercentage) : unansweredPercentage.toFixed(2))
                    return <div>
                        <ProgressBar>
                            <ProgressBar className="progress-greenColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students answered correctly`} now={isNaN(correctPercentage) ? 0 : (correctPercentage)} key={chapterId + "_" + 1} />
                            <ProgressBar className="progress-redColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students answered incorrectly`} now={isNaN(wrongPercentage) ? 0 : (wrongPercentage)} key={chapterId + "_" + 2} />
                            <ProgressBar className="progress-blueColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students need practice in`} now={isNaN(partialPercentage) ? 0 : (partialPercentage)} key={chapterId + "_" + 3} />
                            <ProgressBar className="progress-greyColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students did not answer`} now={isNaN(unansweredPercentage) ? 100 : (unansweredPercentage)} key={chapterId + "_" + 4} />
                        </ProgressBar>
                        <br></br>
                        <span className="insightProperty">Student Average: {isNaN(correctPercentage) ? 0 : (correctPercentage)}% correct |
                            {isNaN(wrongPercentage) ? 0 : (wrongPercentage)}% incorrect | {isNaN(partialPercentage) ? 0 : (partialPercentage)}% needs practice | {isNaN(unansweredPercentage) ? 100 : (unansweredPercentage)}% unanswered</span>
                    </div>
                } else {
                    return <div>
                        <ProgressBar>
                            <ProgressBar className="progress-greenColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students answered correctly`} now={0} key={chapterId + "_" + 1} />
                            <ProgressBar className="progress-redColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students answered incorrectly`} now={0} key={chapterId + "_" + 2} />
                            <ProgressBar className="progress-blueColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students need practice in`} now={0} key={chapterId + "_" + 3} />
                            <ProgressBar className="progress-greyColor" aria-label={`Chapter ${chapterVO.chapterNumber} ${chapterVO.chapterTitle}: average percentage of questions students did not answer`} now={0} key={chapterId + "_" + 4} />
                        </ProgressBar>
                        <br></br>
                        <span className="insightProperty">Student Average: 0% correct |
                            0% incorrect | 0% needs practice | 0% unanswered</span>
                    </div>
                }
            } else {
                return <div> </div>
            }
        }
        return (
            <React.Fragment>
                {!this.state.viewTopic ?
                    <div>
                        <Spinner
                            loading={this.state.loading}
                            imageSrc={loaderColors1}
                            overlayBackground="rgba(0,0,0,0.5)"
                            label="Loading study center"
                        />
                        <Header userVO={this.state.userVO} bookVO={this.state.bookVO} pageName="study" ></Header>
                        <StudyCenterHeader userVO={this.state.userVO} />
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row greyDiv">
                                <div className="col-lg-8 col-md-6 col-sm-12 headingDiv studyMarginHead">
                                    <span className="insightProperty">{this.state.bookVO !== null ? this.state.bookVO.bookTitle : ""}</span><br />
                                    <span className="insightHeading">Study Center</span>
                                </div>
                                <div ref={this.DropdownRef} className="col-lg-4 col-md-6 col-sm-12 viewhead" style={{ display: 'inline-flex', justifyContent: 'center', margin: 'auto', alignItems: 'center' }}>
                                    <div className="insightProperty">View results for:</div>
                                    <a data-testid="selectClassDropdown" className="fontAwesomeBlackColor" href="javascript:void(0)" onClick={this.handleClick}>
                                        <div ref={this.Dropdowncontainer}
                                            className={this.state.isOpen ? "dropdown active IphoneMargin" : "dropdown IphoneMargin"}
                                            style={{ marginLeft: '15px', width: '210px', background: '#FFFFFF 0% 0% no-repeat padding-box', border: '1px solid #000000', zIndex: '999' }}>
                                            <div className="dropdown__text">
                                                <div className="textOverflowClass"> {!this.state.haveText ? "Select Class" : this.state.haveText}</div>
                                            </div>
                                            {itemList(chapters)}
                                        </div>
                                    </a>
                                </div>
                                <div aria-live="assertive" style={{ position: 'absolute', left: '-9999px' }}>{this.state.routeChangeMsg}</div>
                            </div>
                            <div className="row">
                                <div className="studyDiv">
                                    {this.state.studyDashBoardVO !== null ?
                                        <div>
                                            {this.state.studyDashBoardVO.studyDashBoardDetail !== null ?
                                                this.state.studyDashBoardVO.studyDashBoardDetail.map((studyDashBoard, index) => (
                                                    <div>
                                                        <div>
                                                            <span className="studyHeading" id="secondMenu">Chapter {studyDashBoard.chapterVO.chapterNumber}</span>
                                                            <button className="viewTopicButton" chapternum={studyDashBoard.chapterVO.chapterNumber} chapterId={studyDashBoard.chapterVO.chapterId} onClick={this.navigateToChapterStudyCenter} style={{ float: 'right' }}>View Topics</button>
                                                        </div>
                                                        <span className="insightProperty">{studyDashBoard.chapterVO.chapterTitle}</span>
                                                        <br />
                                                        <span className="insightProperty">{getTotalQuestions(studyDashBoard.chapterVO.distinctChapterResponseList)} questions</span> <br />
                                                        {getProgressBar(studyDashBoard.chapterVO, this.state.studyDashBoardVO.numberOfEnrolledStudentInClass, studyDashBoard.chapterVO.chapterId)}
                                                        <hr />
                                                        <br />
                                                    </div>
                                                ))
                                                : null}
                                        </div> : null}
                                    <br />
                                    <div>
                                        <span className="insightHeading">
                                            About the Connected eBook Study Center
                                        </span>
                                        <br /> <br />
                                        <span className="insightProperty">
                                            The content in the Study Center is selected and maintained exclusively by Aspen Publishing and a team of professor reviewers and editors, not by the authors of your book. These materials typically come from one or more of Aspen Publishing's top study aids, including Examples & Explanations, Glannon Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may be created with assistance from AI tools. Study material sources and activity types vary depending on availability for any given chapter, topic, or course.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                <Footer />
            </React.Fragment>
        );
    }
}
export default withAuth(withRouter(StudyCenterProfessor));